// @flow
import React, { Component } from 'react'
import axios from 'axios'
import LineChart from './Chart1'
import { Row, Col, Icon, Radio } from 'antd'
import { StyledSection, StyledCard, StyledTable } from './style'

const RadioButton = Radio.Button
const RadioGroup = Radio.Group

type State = {
    data: Object[],
    data1: Object,
    isLoading: boolean,
    symbol: string,
}

const dataSource = [{
    key: '1',
    name: 'SPY',
    text: 'S&P 500',
}, {
    key: '2',
    name: 'QQQ',
    text: 'Nasdaq',
},{
  key: '3',
  name: 'IWM',
  text: 'Russell 2000',
},
  {
    key: '4',
    name: 'DIA',
    text: 'DOW',
}, {
    key: '5',
    name: 'VXX',
    text: 'VXX',
}];

const columns = [
    {title: 'Symbol', dataIndex: 'name', key: 'name'},
    {title: 'Price', dataIndex: 'latestPrice', key: 'Price'},
    {title: 'Change', dataIndex: 'change', key: 'Change'},
    {title: 'Percent', dataIndex: 'changePercent', key: 'Percent', render: text => <span key={text} style={{color: `${text >= 0 ? 'green' : 'red'}`}}>{text}% {text >= 0 ? <Icon type="arrow-up" /> : <Icon type="arrow-down" />}</span>},
];

class ViewMarkets extends Component<{}, State> {

    state: State = {
        data: {
            labels: [],
            datasets: [{
                label: 'My Second dataset',
                fillColor: 'rgba(151,187,205,0.2)',
                strokeColor: 'rgba(151,187,205,1)',
                pointColor: 'rgba(151,187,205,1)',
                pointStrokeColor: '#fff',
                pointHighlightFill: '#fff',
                pointHighlightStroke: 'rgba(151,187,205,1)',
                data: [],
            }]

        },
        isLoading: true,
        symbol: 'SPY',
        period: '1d',
    }

    componentDidMount() {
        this.getTableSource()
        this.interval = setInterval(() => {
            this.getTableSource()
        }, 15000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    getTableSource = () => {
        Promise.all([
            axios.get(`https://cloud.iexapis.com/v1/stock/SPY/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
            axios.get(`https://cloud.iexapis.com/v1/stock/QQQ/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
            axios.get(`https://cloud.iexapis.com/v1/stock/IWM/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
            axios.get(`https://cloud.iexapis.com/v1/stock/DIA/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
            axios.get(`https://cloud.iexapis.com/v1/stock/VXX/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
        ]).then((values) => {
            const marketList = []
            values.forEach((market, i) => {
                market.data.key = i+1
                market.data.name = market.data.symbol;
                if (market.data.changePercent) {
                  let changePercent = market.data.changePercent * 100
                  market.data.changePercent = changePercent.toFixed(2);
                }
                marketList.push(market.data)
            })
            this.setState({
                marketList
            })
        });
        this.getChartData()
    }

    getChartData = async () => {

        const { symbol, period } = this.state

        try {
            const response = await axios.get(`https://cloud.iexapis.com/v1/stock/${symbol}/chart/${period}?chartInterval=5&token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)
            const chartData = {
                labels: [],
                datasets: [{
                    label: 'My Second dataset',
                    fillColor: 'rgba(151,187,205,0.2)',
                    strokeColor: 'rgba(151,187,205,1)',
                    pointColor: 'rgba(151,187,205,1)',
                    pointStrokeColor: '#fff',
                    pointHighlightFill: '#fff',
                    pointHighlightStroke: 'rgba(151,187,205,1)',
                    data: [],
                }]

            }
            let label = null
            if (response && response.data) {

                if (response.data.length > 0) {
                  label = `From: ${response.data[0].label} To: ${response.data[response.data.length-1].label}`
                }
                
                response.data.forEach(x => {
                    chartData.labels.push('')
                    chartData.datasets[0].data.push(x.close)
                })
            }
            this.setState({
                data: chartData,
                isLoading: false,
                label
            })

        } catch(err) {

            this.setState({
                isLoading: false,
            })
        }
    }

    onChange = ({ target }) => {
        this.setState({ period: target.value, isLoading: true, }, () => this.getChartData())
    }

    onChangeSymbol = (symbol) => {
        this.setState({
            symbol: symbol.symbol,
            isLoading: true,
        }, ()=> {
            this.getChartData()
        })
    }

    render() {

        const {
            isLoading,
            data,
            marketList,
            period,
            label
        } = this.state

        return (
             <StyledSection>
                    <StyledCard
                        bordered={false}
                        title={<span>Market: {this.state.symbol}</span>}>
                        <Row>
                            <Col span={10}>
                                <StyledTable
                                  onRow={(record) => {
                                    return {
                                      onClick: () => {
                                        this.onChangeSymbol(record)
                                      }
                                    };
                                  }}
                                  style={{marginTop: -16}}
                                  pagination={false}
                                  showHeader={false}
                                  dataSource={marketList}
                                  columns={columns}/>
                            </Col>
                            <Col span={14}>
                                {isLoading ?
                                    <Col span={12}>Loading....</Col> :
                                    <div>
                                        <RadioGroup defaultValue='1d' value={period} onChange={this.onChange}>
                                            <RadioButton value='1d'>1D</RadioButton>
                                            <RadioButton value='1m'>1M</RadioButton>
                                            <RadioButton value='3m'>3M</RadioButton>
                                            <RadioButton value='6m'>6M</RadioButton>
                                            <RadioButton value='1y'>1Y</RadioButton>
                                            <RadioButton value='2y'>2Y</RadioButton>
                                            <RadioButton value='5y'>5Y</RadioButton>
                                        </RadioGroup>
                                        <LineChart data={data}/>
                                        {label && <p className="chartLabels">{label}</p>}
                                    </div>
                                }
                                {
                                    data.length < 2 && !isLoading && <div> No data found. Please change filters.</div>
                                }
                            </Col>
                        </Row>
                    </StyledCard>
                </StyledSection>
        )
    }
}

export default ViewMarkets



// WEBPACK FOOTER //
// ./src/components/view-markets/index.js